export const READ_PERMISSION = 'READ_PERMISSION'

export const ANALYTICS_MODULE = 'ANALYTICS_MODULE'
